import L00 from "./chp-json/L00.json";
import L01 from "./chp-json/L01.json";
import L02 from "./chp-json/L02.json";
import L03 from "./chp-json/L03.json";
import L04 from "./chp-json/L04.json";
import L05 from "./chp-json/L05.json";
import L06 from "./chp-json/L06.json";
import L07 from "./chp-json/L07.json";
import L08 from "./chp-json/L08.json";
import L09 from "./chp-json/L09.json";
import L10 from "./chp-json/L10.json";
import L11 from "./chp-json/L11.json";
import L12 from "./chp-json/L12.json";
import L13 from "./chp-json/L13.json";
import L14 from "./chp-json/L14.json";
import L15 from "./chp-json/L15.json";
import L16 from "./chp-json/L16.json";
import L17 from "./chp-json/L17.json";
import L18 from "./chp-json/L18.json";
import L19 from "./chp-json/L19.json";
import L20 from "./chp-json/L20.json";
import L21 from "./chp-json/L21.json";
import L22 from "./chp-json/L22.json";
import L23 from "./chp-json/L23.json";
import L24 from "./chp-json/L24.json";
import L25 from "./chp-json/L25.json";
import L26 from "./chp-json/L26.json";

export const CHP_LESSON_DATA = new Map<string, any>([
  ["L00", L00],
  ["L01", L01],
  ["L02", L02],
  ["L03", L03],
  ["L04", L04],
  ["L05", L05],
  ["L06", L06],
  ["L07", L07],
  ["L08", L08],
  ["L09", L09],
  ["L10", L10],
  ["L11", L11],
  ["L12", L12],
  ["L13", L13],
  ["L14", L14],
  ["L15", L15],
  ["L16", L16],
  ["L17", L17],
  ["L18", L18],
  ["L19", L19],
  ["L20", L20],
  ["L21", L21],
  ["L22", L22],
  ["L23", L23],
  ["L24", L24],
  ["L25", L25],
  ["L26", L26],
]);
